import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptService } from 'app/services/receipt-service';
import { ActionItem } from '../../actions-dropdown/actions-dropdown.component';

@Component({
  selector: 'app-product-last-receipt',
  templateUrl: './product-last-receipt.component.html',
  styleUrls: ['./product-last-receipt.component.scss']
})
export class ProductLastReceiptComponent implements OnChanges {

  @Input() data;
  @Input() policyNumber: string;

  /** Opciones del desplegable PAGAR (mismas que en el listado de recibos del perfil). */
  payActions: ActionItem[] = [];

  constructor(private receiptService: ReceiptService, private router: Router) { }

  ngOnChanges() {
    this.payActions = this.data ? this.buildPayActions() : [];
  }

  /** El recibo está pendiente (rojo) y no es un extorno, o es un documento de cobro pendiente. */
  get canPay(): boolean {
    if (!this.data || 'red' !== this.data.receiptStatusColor) {
      return false;
    }
    return 'E' !== this.data.receiptType || !!this.data.docCobroNumber;
  }

  pay() {
    this.receiptService.payment(this.data);
  }

  private buildPayActions(): ActionItem[] {
    return [
      {
        label: 'Tarjeta',
        icon: 'card',
        action: () => this.pay()
      },
      {
        label: 'Cuenta bancaria',
        icon: 'bank',
        action: () => this.router.navigate(['/receipt', 'nw', this.data.receiptNumber])
      }
    ];
  }

}
